(() => {
  const instances = new WeakSet();
  function initialize(root) {
    if (instances.has(root)) return;
    instances.add(root);
    const upload = root.querySelector('.product-upload-field');
    const notes = root.querySelector('.product-message-field');
    let quantity = Number(root.querySelector('form.f8pr-buy-button [name="quantity"]')?.value || 1);
    root.addEventListener('change', event => {
      if (event.target.matches('input[name="variant-id"],select[name="variant-id"],input[name^="options["],select[name^="options["]')) {
        quantity = Number(root.querySelector('form.f8pr-buy-button [name="quantity"]')?.value || 1);
      }
    }, true);
    const observer = new MutationObserver(() => {
      const form = root.querySelector('form.f8pr-buy-button');
      if (!form) return;
      const newUpload = form.querySelector('.product-upload-field');
      if (upload && newUpload && newUpload !== upload) {
        newUpload.replaceWith(upload);
        const newNotes = form.querySelector('.product-message-field');
        if (notes && newNotes && newNotes !== notes) newNotes.replaceWith(notes);
        const amount = form.querySelector('[name="quantity"]');
        if (amount) amount.value = Math.min(Number(amount.max || Infinity), Math.max(Number(amount.min || 1), quantity));
      }
    });
    observer.observe(root, {childList:true,subtree:true});
  }
  const start = () => document.querySelectorAll('[data-upload-product]').forEach(initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
  document.addEventListener('shopify:section:load', start);
})();
